// frontend/src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import preferencesReducer from './slices/preferencesSlice';
import assignmentsReducer from './slices/assignmentsSlice';

export const store = configureStore({
  reducer: {
    preferences: preferencesReducer,
    assignments: assignmentsReducer,
  },
});
